var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invitation-to-organization-page"},[_c('OrganizationJoin',{attrs:{"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }